import { useState } from 'react';

import { consultationApi, consultationStatus, useConsultation } from '@entities/consultations';

import { xhr } from '@shared/config';

export const useConsultationCost = (id: number) => {
	const { consultation } = useConsultation(id);

	const costTitle = consultation?.paid.prepayment ? 'Предоплата' : 'Стоимость';

	// const showDebt = consultation
	// 	? consultation.cost.full_cost > consultation.cost.amount + consultation.payments
	// 	: false;

	const status = consultationStatus(consultation);

	const showDebt = consultation?.paid.prepayment && status === 'confirmed';

	return { costTitle, showDebt };
};

export const usePrepaid = (id: number) => {
	const { consultation, updateConsultation } = useConsultation(id);
	const [isPrepaidOpen, setIsPrepaidOpen] = useState(false);
	const [amount, setAmount] = useState('0');

	const togglePrepaid = () => setIsPrepaidOpen((p) => !p);

	const onPay = async () => {
		if (!consultation) return;

		try {
			const data = {
				mode: 'INCOME',
				amount: amount,
			};
			const res = await xhr.post<{ amount: number }>(`${consultationApi}${id}/add_payment/`, data);

			if (!res.data) throw res;

			updateConsultation(id, { payments: consultation.payments + res.data.amount });
		} catch (error) {
			console.log(error);
		}
	};

	return {
		isPrepaidOpen,
		togglePrepaid,
		amount,
		setAmount,
		onPay,
	};
};
